import React from 'react'
import expandLogo from '../../../assets/images/Expand Arrow copy.png';

const UserSelect = (props) => {
    let { user, setUser, selectUser, userData, setExpand, expand } = props;

    const handleClick = (user) => {
        setUser(user);
        setExpand(false);
    }

    return (
            <div className='flex z-30 relative w-full'>
                <div className={`bg-bgColor text-fgColor px-2 py-2 w-full flex items-center justify-between rounded-sm cursor-pointer shadow-lg `}
                    onClick={(e) => selectUser(e)}>
                    <div>{user.name}</div>
                    <img src={expandLogo} alt="Expand-logo" className='w-6' />
                </div>
                {
                    expand ?
                        <div className="bg-bgColor text-fgColor w-full absolute top-[45px] cursor-pointer overflow-auto h-[210px] shadow-lg ">
                            {
                                userData && userData.map((user, index) => (
                                    <div key={index}
                                        className={`${user.userId !== user.length ? "border-b-2" : "border-b-0"}  py-2
                                        px-4 hover:bg-primary hover:text-rectangle  transition-all duration-100 `}
                                        onClick={()=>handleClick(user)}
                                    >
                                        {user.name}
                                    </div>
                                ))
                            }
                        </div> : ""
                }
                
            </div>
        )
}

export default UserSelect